/* eslint-disable no-unused-vars */
import './ScenesStyles.scss';
import React, { useEffect, useLayoutEffect, useRef } from 'react';
import useGsapContext from '../../../hooks/UseGsapContext';
import gsap from 'gsap';
import ModalBtn from '../../ModalScene/ModalBtn';
import { useDispatch, useSelector } from 'react-redux';
import ScrollControls from '../../MobileControls/MobileControls';
import { selectScene } from 'src/app/redux/slice/sceneSlice';

const scenesImages = require.context('../../../../assets/scenes');

const Scene11 = ({ data, fs, allowScroll }) => {
  const dispatch = useDispatch();
  const newCurrentScene = useSelector(
    (state) => state.sceneController.newCurrentScene
  );
  const isBack = useRef(false);

  const scene = useRef();

  const ctx = useGsapContext(scene);

  // Change Scene & Animation
  const changeScene = (id) => {
    console.log('NEXT');
    gsap.to(scene.current, {
      opacity: 0,
    });
    setTimeout(() => {
      dispatch(selectScene(id));
    }, 500);
  };
  // Animations
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    ctx.add(() => {
      gsap.set(scene.current, { opacity: 0 });
      gsap.to(scene.current, {
        opacity: 1,
        keyframes: { y: [100, 0] },
        duration: 0.8,
      });
    });
    return () => ctx.revert();
  });

  useEffect(() => {
    isBack.current = false;
    allowScroll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <>
      <div
        className={(newCurrentScene - 1) % 2 ? ' container' : 'container'}
        ref={scene}
      >
        <div className="scene-mobile">
          <div className="scene-mobile-title">
            <h2 className="" style={{ fontSize: `calc(1em + ${fs})` }}>
              {data?.title}
            </h2>
          </div>
          <div className="scene-mobile-collage">
            <div className="scene-mobile-collage-parallax">
              <img
                aria-hidden="true"
                className="img3 parallax"
                data-depth={'0.17'}
                src={scenesImages(data?.collage?.img1?.url)}
                width="321px"
                alt=""
              />
              <img
                className="img2 parallax"
                width="321px"
                height={'auto'}
                data-depth={'0.18'}
                src={scenesImages(data?.collage?.img2?.url)}
                alt="Collage representativo"
              />
              <img
                aria-hidden="true"
                className="img3 parallax"
                data-depth={'0.17'}
                src={scenesImages(data?.collage?.img3?.url)}
                width="321px"
                alt=""
              />
            </div>
          </div>
          <div className="scene-mobile-textbox">
            <h3 className="">
              {data?.subtitle}
              <br />
              {data?.date}
            </h3>
            {data?.description?.map((item, index) => (
              <div
                className="scene-textbox-format"
                key={`${index}`}
                dangerouslySetInnerHTML={{ __html: item }}
              ></div>
            ))}
            <ModalBtn data={data?.options} title="Conoce más" />
          </div>
        </div>
      </div>
      <div className="scroll-controls">
        {data?.sceneTransition?.prev && (
          <button
            onClick={() => changeScene(data?.sceneTransition?.prev)}
            aria-label="Previous"
          >
            <div className="scroll-prev"></div>
          </button>
        )}
        {data?.sceneTransition?.prev && data?.sceneTransition?.next && (
          <span className="scroll-controls-split"></span>
        )}
        {data?.sceneTransition?.next && (
          <button
            onClick={() => changeScene(data?.sceneTransition?.next)}
            aria-label="Next"
          >
            <div className="scroll-next"></div>
          </button>
        )}
      </div>
    </>
  );
};

export default Scene11;
